module.exports = __webpack_public_path__ + "img/horizontal_6_3_7042.8a8e331e.png";